import { Drawer } from 'antd'
import React from 'react'

import { drawerAndModalWidth } from '../../../../util/guideline'
import { Tenant } from '../../../Tenants/models'
import { Issuer, RfqEmail } from '../../models'
import { UpdateBespokeRfqEmails } from './UpdateBespokeRfqEmails'

interface UpdateBespokeRfqEmailDrawerProps {
  rfqEmail: RfqEmail
  isVisible: boolean
  onClose: () => void
  issuers: Issuer[]
  tenants: Tenant[]
  onSuccess: () => void
}

export const UpdateBespokeRfqEmailDrawer = ({
  rfqEmail,
  issuers,
  tenants,
  isVisible,
  onClose,
  onSuccess,
}: UpdateBespokeRfqEmailDrawerProps) => (
  <Drawer
    title="Update Bespoke RFQ Email"
    placement="right"
    onClose={onClose}
    open={isVisible}
    width={drawerAndModalWidth}
    destroyOnClose
    className="drawer-rfq"
  >
    <UpdateBespokeRfqEmails rfqEmail={rfqEmail} issuers={issuers} tenants={tenants} onSuccess={onSuccess} />
  </Drawer>
)
